<template>
  <v-dialog v-model="dialog" persistent width="500">
    <v-card>
      <ModalHeader
        title="Edit Employee Benefits"
        icon="mdi-account-edit"
        @close="dialog = false"
      />
      <v-card-text class="pa-4">
        <v-select
          label="Employee"
          dense
          outlined
          item-text="name"
          item-value="id"
          :items="employees"
          v-model="item.employee_id"
        ></v-select>
        <v-select
          label="Benefit"
          dense
          outlined
          item-text="name"
          item-value="id"
          :items="benefits"
          v-model="item.benefit_id"
        ></v-select>
        <v-text-field
          label="Account Number"
          dense
          outlined
          v-model="item.account_number"
        ></v-text-field>
        <!-- date issued -->
        <div class="d-flex">
          <p class="mr-2">Date Issued</p>
          <input type="date" v-model="item.date_issued" class="mt-n3" />
        </div>
      </v-card-text>
      <v-card-actions>
        <v-btn color="primary" @click="submit" :loading="loading">Submit</v-btn>
        <v-btn @click="$emit('close')"> Close</v-btn>
        <v-spacer></v-spacer>
        <p class="caption grey--text">itemProfileModal.vue</p>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
export default {
  props: ["item"],
  data() {
    return {
      dialog: true,
      loading: false,
    };
  },
  computed: {
    ...mapGetters({
      employees: "employee/employees",
      benefits: "benefit/benefits",
    }),
  },
  methods: {
    ...mapActions({
      edit_employee_benefit: "employee_benefit/edit_employee_benefit",
    }),

    async submit() {
      // confirm
      let x = await this.$confirm({
        title: "Edit Employee Benefit",
        message: "Are you sure you want to edit this employee benefit?",
        color: "primary",
        icon: "mdi-pencil",
      });
      if (!x) return;
      this.loading = true;
      this.edit_employee_benefit(this.item);
      this.$alert({
        title: "Success",
        message: "Successfully edited an employee benefit",
        color: "success",
        icon: "mdi-check-circle",
      });
      this.loading = false;
      this.$emit("close");
    },
  },
};
</script>

<style lang="scss" scoped></style>
